import ChevronDown from '@assets/icons/chevron-down.svg'
import { Icon } from './Icon'

export const ChevronDownIcon = Icon(ChevronDown)
